import { Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { OmpEditorHistoryService } from '../../../_services';

// Shared rich-text editor for OMP section settings. Owns the single TinyMCE config so every
// section editor stays consistent; the <editor> auto-generates a unique id when none is given.
@Component({
  selector: 'omp-rte',
  templateUrl: './omp-rte.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpRteComponent implements OnInit, OnChanges {
  public value: string;
  @Input() allowRightAlign = true;
  @Input() allowAlign = true;
  @Input() allowColor = true;
  @Input() allowLists = true;
  @Input() previewBackground = '';
  @Output() valueChange = new EventEmitter<string>();

  private editor: any = null;

  public init: any = {
    plugins: 'lists link autoresize paste emoticons omp-icons path-variables contrast-background swatch-colors',
    toolbar:
      'swatch-forecolor | bold italic underline | alignleft aligncenter alignright | link | ' +
      'bullist numlist | emoticons omp-icons | path-variables | contrast-background',
    menubar: false,
    branding: false,
    statusbar: false,
    paste_as_text: true,
    extended_valid_elements: 'i[class|style|aria-hidden]',
    content_css: ['default'].concat(
      ['fontawesome', 'solid', 'regular', 'brands'].map((file) => window.location.origin + '/fontawesome/css/' + file + '.min.css')
    ),
    min_height: 120,
    max_height: 260,
    autoresize_bottom_margin: 8,
    forced_root_block: 'p',
    init_instance_callback: () => {},
    setup: (editor: any) => {
      this.editor = editor;
      editor.on('PastePreProcess', (event: any) => {
        event.content = this.linesToParagraphs(event.content);
      });
      editor.on('keydown paste', () => {
        if (this.history) {
          this.history.touchTextGroup();
        }
      });
      editor.on('blur', () => {
        if (this.history) {
          this.history.endGroup();
        }
      });
    },
    content_style:
      "body{ font-family:'Inter', sans-serif; font-size:16px; line-height:1.5; color:#163549; margin:12px; } p{ margin:0 0 8px; }",
  };

  constructor(@Optional() private history: OmpEditorHistoryService) {}

  @Input('value')
  set incomingValue(value: string) {
    let cleaned = value;
    if (cleaned) {
      cleaned = cleaned.replace(/overflow-y:\s*hidden;?\s*/gi, '');
      cleaned = cleaned.replace(/\s*style=(""|'')/gi, '');
    }
    this.value = cleaned;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.previewBackground && this.editor) {
      this.applyPreviewBackground();
    }
  }

  private linesToParagraphs(content: string): string {
    let result = content;
    if (content && /<br\s*\/?>/i.test(content)) {
      const lines = content
        .replace(/<\/?p[^>]*>/gi, '')
        .split(/<br\s*\/?>/i)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
      if (lines.length > 1) {
        result = lines.map((line) => '<p>' + line + '</p>').join('');
      }
    }
    return result;
  }

  private applyPreviewBackground() {
    const body = this.editor.getBody();
    if (body) {
      body.style.background = this.previewBackground ? this.previewBackground : '';
    }
  }

  ngOnInit() {
    if (this.previewBackground) {
      this.init.content_style += ` body{ background:${this.previewBackground}; }`;
    }
    if (!this.allowRightAlign) {
      this.init.toolbar = this.init.toolbar.replace(' alignright', '');
    }
    if (!this.allowAlign) {
      this.init.toolbar = this.init.toolbar.replace(/alignleft aligncenter( alignright)? \| /, '');
    }
    if (!this.allowColor) {
      this.init.toolbar = this.init.toolbar.replace('swatch-forecolor | ', '');
    }
    if (!this.allowLists) {
      this.init.toolbar = this.init.toolbar.replace('bullist numlist | ', '');
      this.init.plugins = this.init.plugins.replace('lists ', '');
    }
  }

}
